<script>
	import Icon from "@iconify/svelte";
	import { colorMain, api_engage } from "./stores.js";
	import { getExpParams } from "./utils.js";
    import Navbar from "./components/Navbar.svelte";

	export let engageType;
	export let engageValue;
	export let entity_id;
	export let entity_url;
	export let idx;
	export let icon;
	export let iconClicked;
	export let tooltiptitle;

	let entities_engage = JSON.parse(localStorage.getItem("entities_engage"));
	let lastViewTime;
	let engageTime;
	let engageRT;
	let clickable = true;
	let clicked = 0;

	let currentIcon = icon;
	let engageValueInvisible = false;
	let engageAlwaysInvisible = false;

	let clickedColor = $colorMain;
	let currentColor = $colorMain;
	if (engageType === "shares") {
		clickedColor = "#083d77";
	} else if (engageType === "likes") {
		clickedColor = "#da4167";
	} else if (engageType === "read_later") {
		clickedColor = "#f6d8ae";
	} else if (engageType === "accuracy_score") {
		clickedColor = "#2e4057";
	} else if (engageType === "upvote") {
		clickedColor = "#4d904b";
	} else if (engageType === "downvote") {
		clickedColor = "#b74242";
	}

	let expParams = getExpParams();
	// if 'yes', only show button but don't show value, otherwise, show button and value
	if (engageType === "shares") {
		if (expParams["feed-button-share"] === "yes") {
			engageValue = 0;
			engageValueInvisible = true;
			engageAlwaysInvisible = true;
		}
	} else if (engageType === "likes") {
		if (expParams["feed-button-like"] === "yes") {
			engageValue = 0;
			engageValueInvisible = true;
			engageAlwaysInvisible = true;
		}
	} else if (engageType === "read_later") {
		if (expParams["feed-button-bookmark"] === "yes") {
			engageValue = 0;
			engageValueInvisible = true;
			engageAlwaysInvisible = true;
		}
	} else if (engageType === "accuracy_score") {
		if (expParams["feed-button-accuracy"] === "yes") {
			engageValue = 0;
			engageValueInvisible = true;
			engageAlwaysInvisible = true;
		}
	} else if (engageType === "upvote") {
		if (expParams["feed-button-upvote"] === "yes") {
			engageValue = 0;
			engageValueInvisible = true;
			engageAlwaysInvisible = true;
		}
	} else if (engageType === "downvote") {
		if (expParams["feed-button-downvote"] === "yes") {
			engageValue = 0;
			engageValueInvisible = true;
			engageAlwaysInvisible = true;
		}
	}

	if (engageType == "accuracy_score") {
		clickable = false;
	}

	const truncateToOneDigit = (num) => {
		return Math.floor(num * 10)/10;
	}

	const parseEngageValue = (engageValue, clicked) => {
		if (engageType != "accuracy_score") {
			engageValue = parseInt(engageValue);
			if (clicked) {
				if (isNaN(engageValue)) {engageValue = 1;}
				else {engageValue++;}
			}
			if (engageValue < 1 || isNaN(engageValue)) {
				engageValueInvisible = true;
			}
			if (engageValue < 10000) { // max 9999
				engageValue = engageValue.toLocaleString();
			}
			else if (engageValue < 1000000) { // max 999.9k
				engageValue = truncateToOneDigit((engageValue / 1000)) + 'K';
			}
			else if (1000000 <= engageValue) { // min 1m
				engageValue = truncateToOneDigit((engageValue / 1000000)) + 'M';
			}
		}
		return engageValue;
	};

	// create entity object in localStorage if it doesn't exist
	if (entities_engage[entity_id] === undefined) {
		entities_engage[entity_id] = {};
		entities_engage[entity_id]["idx"] = idx;
		entities_engage[entity_id]["entity_id"] = entity_id;
		entities_engage[entity_id][engageType] = 0;
		entities_engage[entity_id]["lastViewTime"] = -1;
		entities_engage[entity_id]["lastEngageTime"] = -1;
		entities_engage[entity_id]["lastRT"] = -1;
		entities_engage[entity_id]["dwells"] = 0;
		entities_engage[entity_id]["dwellTimes"] = [];
		entities_engage[entity_id]["dwellsInviewTime"] = [];
	}
	// create engageType in entity if it doesn't exist
	if (entities_engage[entity_id][engageType] === undefined) {
		entities_engage[entity_id][engageType] = 0;
	}
	localStorage.setItem("entities_engage", JSON.stringify(entities_engage));
	entities_engage = JSON.parse(localStorage.getItem("entities_engage"));

	
	// if value is 1, ensure it's clicked
	if (entities_engage[entity_id][engageType] === 1) {
		clicked = 1;
		currentIcon = iconClicked;
		currentColor = clickedColor;
	}

	// if clicked, always make value visible
	$: if (clicked) {
		if (!engageAlwaysInvisible) {
			engageValueInvisible = false;
		}
	}

	const handleClick = () => {
		if (!clickable) {
			console.log("Not clickable");
			return false;
		}
		engageTime = +new Date();
		let entities_engage = JSON.parse(
			localStorage.getItem("entities_engage")
		);
		entities_engage[entity_id]["lastEngageTime"] = engageTime;
		lastViewTime = entities_engage[entity_id]["lastViewTime"];

		if (lastViewTime !== -1) {
			engageRT = engageTime - lastViewTime;
			entities_engage[entity_id]["lastRT"] = engageRT;
		}

		console.log(idx, entity_id, entity_url);
		console.log("engageTime & engageRT:", engageTime, engageRT);

		if (clicked) {
			currentIcon = icon;
			currentColor = $colorMain;
			entities_engage[entity_id][engageType] -= 1;
		} else {
			currentIcon = iconClicked;
			currentColor = clickedColor;
			entities_engage[entity_id][engageType] += 1;
		}
		localStorage.setItem(
			"entities_engage",
			JSON.stringify(entities_engage)
		);
		clicked = !Number(clicked);
		console.log(engageType, "clicked:", clicked, engageValue + clicked);
		writeUserEngagement();
	};

	async function writeUserEngagement() {
		console.log("Writing user engagement...");
		const resp = await fetch($api_engage, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				user_id: localStorage.getItem("user_id"),
				entity_id: entity_id,
				condition: localStorage.getItem("condition"),
				experiment_id: localStorage.getItem("experiment_id"),
				engagement_type: engageType,
				response: Number(clicked),
				time_content_viewed: lastViewTime, // last inview time (epoch time ms)
				time_engagement: engageTime, // engage time (epoch time ms)
				// rt: engageRT, // RT (ms): engage time minus last view time
			}),
		});
		const response = await resp.json();
		if (response.success === "true") {
			console.log("Write/post engagement successfully");
		} else {
			console.log("Fail to write/post engagement");
		}
	}
</script>

<span class="tooltip">
	<span class="tooltiptext">{tooltiptitle}</span>
	<span class:unclickable={!clickable} class:clickable>
		<span on:click={handleClick} class="engage-button">
			<span
				class="engage-button:hover hvr-bounce-in"
				entity-id={entity_id}
			>
				<Icon
					icon={currentIcon}
					color={currentColor}
					width="21"
					inline={true}
				/>
			</span>
			<span
				style="--theme-textColor: {currentColor}"
				class="engage-value"
				class:engage-value-hidden={engageValueInvisible}
				entity-id={entity_id}
				>{parseEngageValue(engageValue, clicked)}</span
			>
		</span>
	</span>
</span>

<style>
	.engage-button {
		/* margin: auto; */
		margin: 1px;
		padding: 3px 21px 3px 21px;
		opacity: 0.8;
		width: 22px;
		/* cursor: pointer; */
		display: inline-flex;
	}
	.engage-button:hover {
		opacity: 1;
		/* cursor: pointer; */
		display: inline-flex;
	}
	.engage-value {
		font-size: 11px;
		margin-left: 3px;
		display: inline-flex;
		align-items: center;
		min-height: 8px;
		color: var(--theme-textColor);
	}
	.engage-value-hidden {
		font-size: 11px;
		margin-left: 3px;
		display: inline-flex;
		align-items: center;
		min-height: 8px;
		visibility: hidden;
	}
	@media (max-width: 400px) {
		.engage-button {
			margin: 1px;
			padding: 5px 5px 5px 5px;
			opacity: 0.8;
			/* cursor: pointer; */
			display: inline-flex;
		}
		.engage-value {
			font-size: 8px;
			margin-left: 1px;
			display: inline-flex;
			align-items: center;
			min-height: 8px;
		}
	}

	.tooltip {
		position: relative;
		display: inline-block;
	}

	.tooltip .tooltiptext {
		visibility: hidden;

		/* don't wrap tooltip text */
		white-space: nowrap;
		width: auto;

		background-color: black;
		opacity: 0.3;
		color: #fff;
		text-align: center;
		border-radius: 5px;
		padding: 5px;

		/* Position the tooltip */
		position: absolute;
		z-index: 1;
		top: 89%;
		left: 30%;
	}

	.tooltip:hover .tooltiptext {
		visibility: visible;
	}

	.unclickable {
		cursor: default;
	}
	.clickable {
		cursor: pointer;
	}
</style>
